import { render, staticRenderFns } from "./select-periodo.vue?vue&type=template&id=1c32e364"
import script from "./select-periodo.vue?vue&type=script&lang=ts"
export * from "./select-periodo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports